import { getCdnLink } from 'tools/getCdnLink';

function setReleaseHeaderImage() {
    const panelCards = document.querySelectorAll('[data-press-panel]');
    panelCards.forEach(panelCard => setImage(panelCard));
}

function setImage(panelCard) {
    const dataContent = panelCard.querySelector('[data-releasecontent]');
    if (dataContent) {
        const cmsContentString = dataContent.dataset.releasecontent;
        const cmsContentHtml = document.createElement('div');
        cmsContentHtml.innerHTML = cmsContentString;
        const cmsImageElement = cmsContentHtml.querySelector('img');
        const releaseHeaderImage = panelCard.querySelector('[data-headerimage]');
        if (cmsImageElement) {
            const cmsImageUrl = cmsImageElement.getAttribute('src');
            releaseHeaderImage.setAttribute('src', cmsImageUrl);
        } else {
            releaseHeaderImage.setAttribute('src', getCdnLink('img/news/news-archive.png'));
        }
    }
}

export { setReleaseHeaderImage };
